<template>
  <v-container fluid class="pa-0">
    <v-layout row fluid>
      <v-flex>
        <v-card flat>
          <v-card-text>
            <div  class="headline">
            {{ 'TITLE_SETTINGS' | translate }}
            </div>
            <v-list three-line>
              <v-list-tile v-for="setting in settings" :key="setting.key" style="padding-bottom: 3ex;">
                <v-list-tile-content>
                  {{setting.display}}
                    <v-text-field
                      v-if="setting.type === 'text'"
                      v-model="setting.value"
                      @change="saveSetting(setting.key, $event);"
                    >
                    </v-text-field>
                    <v-select
                      v-if="setting.type === 'select'"
                      v-model="setting.value"
                      :items="setting.selectItems"
                      item-text="display"
                      item-value="_id"
                      @change="saveSetting(setting.key, $event);"
                    >
                    </v-select> 
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <!--
            <v-spacer></v-spacer>
            <HitlistCounter></HitlistCounter>
            <v-spacer></v-spacer>
            -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'Settings.vue',
    components: { },
    data() {
      return {
        settings: {}
       }
    },
    methods: {
      collapseEvent: function (isMini) {
        if (isMini) {
          this.widthSub = 40
  
        } else {
          this.widthSub = 350
        }
      },
      updateSettings: function (data) {
        this.settings = data;
      },
      saveSetting: function (key, newValue) {
        console.log(key, newValue);
        var h = {};
        h[key] = newValue;
        Vue.prototype.$api.setUserSettings(h);
      }
    },
    created() {
    },
    destroyed() {
    },
    mounted() {
      var cmp = this;
      Vue.prototype.$eventHub.$emit('OnGetModuleTitle', 'Settings');
      //var data = null;
      //this.updateSettings(data);
      Vue.prototype.$api.getUserSettings(null, function (data) {
        cmp.updateSettings(data);
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/UserSettings.vue